import store from "./store";
import _ from "lodash";

export default {
    install(Vue: any) {
        // Translate using placeholders:
        // Source string, ex: Opération validée le %date% par %user%.
        // {{ "operationValidated" | trans("", "", {date: "21/03/2023", user: "Toto"}) }}
        Vue.filter("trans", (label: string, type: string = "", ssubType: string = "", context: object = {}) => {
            const replacePlaceholders = (str: string, placeholders: object) => {
                _.forEach(placeholders, (val, key) => {
                    str = str.replace(new RegExp("%" + key + "%", "g"), val);
                });
                return str;
            };
            let value: string = label + "-" + ssubType + "-" + type;
            let result: string = store.getters.translate(value);
            if (result !== value) {
                return replacePlaceholders(result, context);
            }
            value = label + "-" + ssubType + "-label";
            result = store.getters.translate(value);
            if (result !== value) {
                return replacePlaceholders(result, context);
            }

            const client = store.getters.getCurrentOwner;
            value = label + "-" + _.get(client, "canonicalName", "");
            result = store.getters.translate(value);
            if (result !== value) {
                return replacePlaceholders(result, context);
            }

            return replacePlaceholders(store.getters.translate(label), context);
        });
    },
};
